import {Fragment, h, JSX} from 'preact'
import {ProductButtonGrid, ProductButtonGridProps} from './ProductButtonGrid'
import classNames from 'classnames'
import {ArrowDownIcon} from './Icons';

export interface GridViewProps {
    buttons: {
        label: string,
        name: string,
        current: boolean,
        onClick?: () => void
    }[],
    isDropdownOpen?: boolean,
    onDropdownClick?: () => void,
    dropdownLabel?: string,
    grid: ProductButtonGridProps,
}

export const GridView = (props: GridViewProps): JSX.Element => (
    <Fragment>
        <div class="grid-view__navigation border-b relative pb-4 mb-4">
            {props.onDropdownClick && props.dropdownLabel && (
                <button onClick={props.onDropdownClick} className="btn btn-border pl-4 pr-3 py-3 md:hidden gap-1">
                    {props.dropdownLabel}
                    <ArrowDownIcon
                        class={classNames(
                            'transition-transform',
                            props.isDropdownOpen ? 'rotate-180' : 'rotate-0'
                        )}
                    />
                </button>
            )}
            <div
                class={classNames(
                    'absolute md:static md:gap-4 flex-col md:flex-row top-full mt-2 md:mt-0 bg-white rounded-base shadow-dropdown md:shadow-none z-10 md:bg-none md:rounded-none min-w-[192px] md:min-w-0',
                    props.isDropdownOpen ? 'flex' : 'hidden md:flex'
                )}
            >
                {props.buttons.map((button) => (
                    <button
                        class={classNames(
                            'px-4 py-2.5 md:py-3 md:rounded-base md:border md:font-semibold transition-colors text-left md:text-center hover:bg-neutral-100',
                            !button.current && 'md:hover:bg-kinola-complimentary-light-blue md:hover:border-kinola-complimentary-light-blue',
                            button.current && 'bg-neutral-100 md:border-kinola-complimentary-dark-blue md:bg-kinola-complimentary-dark-blue md:hover:border-kinola-complimentary-dark-blue md:hover:bg-kinola-complimentary-dark-blue md:text-white',
                        )}
                        onClick={button.onClick}
                    >
                        {button.label}
                    </button>
                ))}
            </div>
        </div>
        <div class="grid-view__grids">
            <ProductButtonGrid {...props.grid}/>
        </div>
    </Fragment>
)
